import React from 'react';
import { getTotalBemClass, ScoreCell } from 'components/scores';

const LeaderboardCellRoundTotal = ({ scoringCourseRound, player, currentRound }) => {
    const playerTotal = player[`r${currentRound}`];
    const roundTotal = scoringCourseRound.totalPar;
    const difference = playerTotal - roundTotal;
    let bemList = ['default', 'has-border'];

    if (playerTotal && roundTotal && !Number.isNaN(difference)) {
        bemList = [getTotalBemClass(difference), 'has-border'];
    }

    return (
        <div className="leaderboard__cell leaderboard__cell--today">
            <div className="leaderboard__cell-content">
                <ScoreCell
                    childCss='leaderboard__score-cell'
                    bemList={bemList}
                >{playerTotal || '-'}</ScoreCell>
            </div>
        </div>
    );
};

export default LeaderboardCellRoundTotal;
